// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChannelProfile__container-be2591 {
  --padding: 24px;
}

.ChannelProfile__header-e7a982 {
  display: flex;
  padding-bottom: 12px;
  padding-inline-start: var(--padding);
}

.ChannelProfile__avatar-bdb16d {
  display: flex;
  align-items: flex-start;
  margin-inline-end: 16px;
}

.ChannelProfile__info-eb1bf0 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
}

.ChannelProfile__title-de5e45 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--base-110);
  word-break: break-all;
}

.ChannelProfile__subtitle-aab294 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  margin-top: 4px;
}

.ChannelProfile__actions-e059d8 {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 24px 16px;
}

.ChannelProfile__action-button-f8fea0 {
  margin-inline-start: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.ChannelProfile__action-button-icon-c6c9fa {
  display: flex;
  align-items: center;
}

.ChannelProfile__contact-ae6e94 {
  padding: 8px var(--padding);
}

.ChannelProfile__list-item-c8c5dd {
  min-height: 48px;
  padding: 0 var(--padding);
}

.ChannelProfile__list-item-title-d53b28 {
  margin-inline-start: 8px;
}

.ChannelProfile__list-icon-d32950 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/ChannelProfile/ChannelProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  --padding: 24px;\n}\n\n.header {\n  display: flex;\n  padding-bottom: 12px;\n  padding-inline-start: var(--padding);\n}\n\n.avatar {\n  display: flex;\n  align-items: flex-start;\n  margin-inline-end: 16px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.subtitle {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  margin-top: 4px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px 24px 16px;\n}\n\n.action-button {\n  margin-inline-start: 16px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.action-button-icon {\n  display: flex;\n  align-items: center;\n}\n\n.contact {\n  padding: 8px var(--padding);\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 var(--padding);\n}\n\n.list-item-title {\n  margin-inline-start: 8px;\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChannelProfile__container-be2591`,
	"header": `ChannelProfile__header-e7a982`,
	"avatar": `ChannelProfile__avatar-bdb16d`,
	"info": `ChannelProfile__info-eb1bf0`,
	"title": `ChannelProfile__title-de5e45`,
	"subtitle": `ChannelProfile__subtitle-aab294`,
	"actions": `ChannelProfile__actions-e059d8`,
	"action-button": `ChannelProfile__action-button-f8fea0`,
	"actionButton": `ChannelProfile__action-button-f8fea0`,
	"action-button-icon": `ChannelProfile__action-button-icon-c6c9fa`,
	"actionButtonIcon": `ChannelProfile__action-button-icon-c6c9fa`,
	"contact": `ChannelProfile__contact-ae6e94`,
	"list-item": `ChannelProfile__list-item-c8c5dd`,
	"listItem": `ChannelProfile__list-item-c8c5dd`,
	"list-item-title": `ChannelProfile__list-item-title-d53b28`,
	"listItemTitle": `ChannelProfile__list-item-title-d53b28`,
	"list-icon": `ChannelProfile__list-icon-d32950`,
	"listIcon": `ChannelProfile__list-icon-d32950`
};
module.exports = ___CSS_LOADER_EXPORT___;
